// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading_3a7Mh","inner":"Loading_inner_3kssA","icon":"Loading_icon_Fi36u","loader-spin":"Loading_loader-spin_1c--C","loader-stroke":"Loading_loader-stroke_3JEZt"};